import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AlmanacHome from "./components/AlmanacHome";
import VentToDogPage from "./components/VentToDogPage";
import DebatePage from "./components/DebatePage";
import ResultsPage from "./components/ResultsPage";
import ArchivePage from "./components/ArchivePage";
import AboutPage from "./components/AboutPage";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import PreviewTomorrowPage from "./components/PreviewTomorrowPage";
import CommunityDebatePage from "./components/CommunityDebatePage";
import AdminDogsPage from "./components/AdminDogsPage";
import PathWorld from "./components/PathWorld";
import SubscribersAdminPage from "./components/SubscribersAdminPage";
import LinesAdminPage from "./components/LinesAdminPage";
import SeatFighterPage from "./components/SeatFighterPage";
import SeatAdminPage from "./components/SeatAdminPage";
import RevenueAdminPage from "./components/RevenueAdminPage";import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./context/ThemeContext";

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

function App() {
  const [sessionId] = useState(() => {
    // Generate or retrieve anonymous session ID
    const stored = localStorage.getItem('vent_session_id');
    if (stored) return stored;
    const newId = 'anon_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('vent_session_id', newId);
    return newId;
  });

  return (
    <ThemeProvider>
      <div className="App min-h-screen bg-theme noise-overlay">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<AlmanacHome />} />
            <Route path="/vent-to-dog" element={<VentToDogPage />} />
            <Route path="/debate" element={<DebatePage sessionId={sessionId} />} />
            <Route path="/results/:topicId" element={<ResultsPage sessionId={sessionId} />} />
            <Route path="/archive" element={<ArchivePage sessionId={sessionId} />} />
            <Route path="/community/:slug" element={<CommunityDebatePage sessionId={sessionId} />} />
            <Route path="/preview-tomorrow" element={<PreviewTomorrowPage />} />
            <Route path="/admin/dogs" element={<AdminDogsPage />} />
            <Route path="/admin/subscribers" element={<SubscribersAdminPage />} />
            <Route path="/admin/revenue" element={<RevenueAdminPage />} />
            <Route path="/admin/lines" element={<LinesAdminPage />} />
            <Route path="/seat-fighter" element={<SeatFighterPage />} />
            <Route path="/daily-duel" element={<SeatFighterPage />} />
            <Route path="/admin/seat" element={<SeatAdminPage />} />
            <Route path="/path-world" element={<PathWorld />} />
            <Route path="/about" element={<AboutPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
        <PWAInstallPrompt />
      </div>
    </ThemeProvider>
  );
}

export default App;
